import { useEffect, useState } from 'react';
import {
    Edit,
    SimpleForm,
    NumberInput,
    SelectInput,
    TextInput,
    useDataProvider,
} from 'react-admin';
import {
    PLAN_TYPE_CHOICES,
    SUBSCRIPTION_STATUS_CHOICES,
} from './constants';

const UserSubscriptionEdit = () => {
    const dataProvider = useDataProvider();
    const [playerChoices, setPlayerChoices] = useState<Array<any>>([]);

    useEffect(() => {
        let mounted = true;
        dataProvider
            .getList('admin/dropdown/players', {
                pagination: { page: 1, perPage: 1000 },
                sort: { field: '', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => {
                if (mounted) setPlayerChoices(data || []);
            })
            .catch(() => {});

        return () => {
            mounted = false;
        };
    }, [dataProvider]);

    return (
        <Edit>
            <SimpleForm>
                <NumberInput source="id" disabled fullWidth />
                <SelectInput source="user_id" label="Email (Name)" choices={playerChoices} disabled fullWidth />
                <NumberInput source="user_id" label="Player ID" disabled fullWidth />
                <NumberInput source="order_id" disabled fullWidth />
                <SelectInput source="plan_type" choices={PLAN_TYPE_CHOICES} disabled fullWidth />
                <SelectInput source="status" choices={SUBSCRIPTION_STATUS_CHOICES} fullWidth />

                <NumberInput source="billing_anchor_day" min={1} max={31} fullWidth />
                <TextInput source="period_start_date" fullWidth />
                <TextInput source="period_end_date" fullWidth />

                <NumberInput source="ai_analysis_limit" min={0} fullWidth />
                <NumberInput source="ai_dialog_limit" min={0} fullWidth />
                <NumberInput source="video_upload_limit" min={0} fullWidth />
                <NumberInput source="coach_review_limit" min={0} fullWidth />

                <NumberInput source="ai_analysis_used" min={0} fullWidth />
                <NumberInput source="ai_dialog_used" min={0} fullWidth />
                <NumberInput source="video_upload_used" min={0} fullWidth />
                <NumberInput source="coach_review_used" min={0} fullWidth />
            </SimpleForm>
        </Edit>
    );
};

export default UserSubscriptionEdit;
